import { createRef, useEffect, useState } from 'react';
import { Cradle, dayjs, PaginatedEntity, Pagination, UsageStats } from '@solo/app-core';
import { Button, Flex, Text } from '@/app/ui/atoms';
import { useCradle } from '@/app/contexts';
import UsageDetailsTable from '@/app/ui/organisms/Usages/UsageDetailsList';
import { translate } from '@/app/i18n';
import Colors from '@/app/styles/Colors';
import { InputDateWithLabel, Pagination as PaginationComponent } from '@/app/ui';
import DefaultPagination from '@/app/constants/Pagination';

const AllUsageDetails = () => {
  const [usagesData, setUsagesData] = useState<PaginatedEntity<UsageStats>>();
  const { statisticsBloc } = useCradle<Cradle>();

  const fromDateRef = createRef<HTMLInputElement>();
  const toDateRef = createRef<HTMLInputElement>();

  // const digitalPlatforms =
  //   digitalDistributionState.kind === 'LoadedDigitalDistributionState'
  //     ? digitalDistributionState.platforms
  //     : [];

  async function getUsages({
    pagination,
    platform,
    dateFrom,
    dateTo,
  }: {
    pagination?: Pagination;
    platform?: string;
    dateFrom?: Date;
    dateTo?: Date;
  }) {
    const usagesFiltered = await statisticsBloc.getUsages({
      offset: pagination?.offset,
      limit: pagination?.limit,
      platform,
      dateFrom: dateFrom ? dayjs(dateFrom).format('YYYY-MM-DD') : undefined,
      dateTo: dateTo ? dayjs(dateTo).format('YYYY-MM-DD') : undefined,
    });
    setUsagesData(usagesFiltered);
  }

  const jumpToPage = async (page: number) => {
    const pag = { limit: DefaultPagination.limit, offset: DefaultPagination.limit * (page - 1) };
    getUsages({ pagination: pag });
  };

  useEffect(() => {
    getUsages({});
  }, []);

  return (
    <Flex.Container padding="3rem" flexDirection="column">
      <Flex.Container>
        <Text.PageTitle color={Colors.purple}>{translate('NAVBAR.MUSIC_USAGE')} </Text.PageTitle>
        <Text.Title3>&nbsp;/ {translate('PAGE_TITLE.MUSIC_USAGE_DETAIL')}</Text.Title3>
      </Flex.Container>
      <Flex.Container flexDirection="column" className="mt-5" gap="5rem">
        <Flex.Container gap="1rem" alignContent="center" alignItems="center">
          {/* <Flex.Item flex={1}>
            <InputTextAutocomplete
              placeholder="Platform..."
              items={[{ value: 'All', label: 'All' }].concat(
                digitalPlatforms.map((p) => ({ value: p.id.toString(), label: p.name })),
              )}
              onChange={(groupFilter) =>
                groupFilter === 'All' ? getUsages({}) : getUsages({ platform: groupFilter })
              }
            />
          </Flex.Item> */}
          <Flex.Item flex={1}>
            <InputDateWithLabel
              ref={fromDateRef}
              onChange={(date) => getUsages({ dateFrom: date })}
            />
          </Flex.Item>
          <Flex.Item flex={1}>
            <InputDateWithLabel ref={toDateRef} onChange={(date) => getUsages({ dateTo: date })} />
          </Flex.Item>
          <Flex.Item flex={1} style={{ paddingTop: '2px' }}>
            <Button
              $size="md"
              $variant="primary"
              onClick={() => getUsages({ pagination: { limit: DefaultPagination.limit } })}
            >
              <Text.Paragraph style={{ padding: 0 }} fontWeight={600}>
                {translate('WORKS.SEARCH')}
              </Text.Paragraph>
            </Button>
          </Flex.Item>
        </Flex.Container>
        {usagesData !== undefined && (
          <>
            <UsageDetailsTable usages={usagesData.data} />
            <PaginationComponent
              totalElements={usagesData.pagination.totalElements}
              pagination={usagesData.pagination}
              jumpToPage={jumpToPage}
              maxDisplayedPages={8}
            />
          </>
        )}
      </Flex.Container>
    </Flex.Container>
  );
};

export default AllUsageDetails;
